module.exports = __webpack_public_path__ + "img/logo-color.3b931329.png";